export interface BetaOptions {
  drawMarkersAs?: 'no-png' | 'new-png' | 'asset-png' | 'base64-png' | 'base64-svg';
}
export interface MapTypeSettings {
  selectedMapType?: string;
  isTraffic?: boolean;
  isTransit?: boolean;
  isPOI?: boolean;
  isLabled?: boolean;
}

export interface SectionWidgetUserSettings {
  viewMode?: 'workflow-step' | 'layer';
  summary?: 'small' | 'large' | 'hide';
}

export interface WorkflowStepOption {
  uId: string;
  option: 'pending' | 'in-progress' | 'exclude';
}

export enum FolderViewMode {
  Layer = 'layer',
  Workflow = 'workflow'
}

export interface FolderConfiguration {
  viewMode: FolderViewMode;
  workflowStepSortOrder?: string[];
  widgets: FolderWidgetConfig[];
  shapeOpacity: number;
}

export interface FolderWidgetConfig {
  type: FolderWidgetType;
}

export enum FolderWidgetType {
  ListByWorkflowStep = 'list-by-workflow-step'
}

export interface ListByWorkflowStepWidgetConfig extends FolderWidgetConfig {
  type: FolderWidgetType.ListByWorkflowStep;
  size: 'large' | 'small';
  stepsInSummary?: WorkflowStepOption[];
}
